import { useAuth } from '../features/auth/store';
import { useCart } from '../features/cart/store';
import { useWishlist } from '../features/wishlist/store';
let started: Promise<void> | undefined;
/** Restore browser state after the initial render so public HTML hydrates deterministically. */
export function startSession(): Promise<void> {
  started ??= (async () => {
    await useCart.persist.rehydrate();
    useAuth.getState().registerLoginHook(async () => {
      await useCart.getState().syncWithAuth(true);
      await useWishlist.getState().loadIds();
    });
    await useAuth.getState().bootstrap();
    const authed = useAuth.getState().status === 'authenticated';
    await useCart.getState().syncWithAuth(authed);
    if (authed) await useWishlist.getState().loadIds();
  })();
  return started;
}
